import React from 'react';
import Home from '../components/Home';

const HomePage: React.FC = () => {
	return (
	  <div className="min-h-screen w-full bg-gray-100">
	    <Home />
	  </div>
	);
};

export default HomePage;
